import React from 'react'
const GoogleMap=() => {
  return (
    <div className="google-map-code">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1984.110986052722!2d24.944858115729975!3d60.178895181964116!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46920bd4a0ff662b%3A0x52c74c530b79a9a3!2sJuttutupa!5e0!3m2!1sfi!2sfi!4v1677872905382!5m2!1sfi!2sfi"
        title='juttutupa' width="100%" height="450" style={{ border:0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
    </div>
  )
}
export default  GoogleMap